import { render, staticRenderFns } from "./TempAGH.vue?vue&type=template&id=d5f5bf5e&scoped=true&"
import script from "./TempAGH.vue?vue&type=script&lang=js&"
export * from "./TempAGH.vue?vue&type=script&lang=js&"
import style0 from "./TempAGH.vue?vue&type=style&index=0&id=d5f5bf5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f5bf5e",
  null
  
)

export default component.exports